var Timeouts = {
    OneSecond: 1000,
    TwoSeconds: 2000,
    FiveSeconds: 5000,
    TenSeconds: 10000,
    ThirtySeconds: 30000,
    OneMinute: 60000,
    FiveMinutes: 300000,
    TenMinutes: 600000,
    OneHour: 3600000,
    OneDay: 86400000,
    OneWeek: 604800000,
    OneMonth: 2.62974e9,
    OneYear: 3.15569e10
};

var items = {};

items['/activitylist-service/activities/comments/\\S*\\?start=\\d+&limit=\\d+'] = {
    cacheTimeoutMs: Timeouts.TenSeconds
};

items['/activity-service/activity/eventTypes'] = {
    cacheTimeoutMs: Timeouts.OneDay,
    persistToDisk: false
};

items['/activity-service/activity/activityTypes'] = {
    cacheTimeoutMs: Timeouts.OneDay,
    persistToDisk: false
};

// New Cache Options

// These get loaded multiple times on just an ordinary dashboard. I suggestion caching these for at least 5 seconds
// to prevent multiple requests for the same dashboard load
items['/userstats-service/statistics/availability/\\S*'] = {
    cacheTimeoutMs: Timeouts.FiveMinutes,
    persistToDisk: false
};

// Prevent multiple requests for preferences for the same dashboard load
items['/modern/preference/\\S*'] = {
    cacheTimeoutMs: Timeouts.OneMinute,
    persistToDisk: false
};

// These items are heavy hitters that can be cached for longer periods
items['/activitylist-service/activities/comments/subscriptionFeed?&start=\\d+&limit=\\d+'] = {
    cacheTimeoutMs: Timeouts.OneMinute,
    persistToDisk: false
};

items['/course-service/segment/findSegmentsMatchedByActivity?activityId=\\d+'] = {
    cacheTimeoutMs: Timeouts.FiveMinutes,
    persistToDisk: false
};

// prevent multiple models being called/created when user hovers and clicks on Course too fast
items['/course-service/course/\\d+'] = {
    cacheTimeoutMs: Timeouts.TwoSeconds,
    persistToDisk: false
};

// Cache golf club types, these rarely (if ever) change
items['/gcs-golfcommunity/api/v2/club/types'] = {
    cacheTimeoutMs: Timeouts.OneMonth,
    persistToDisk: false
};

// Cache golf flex types, these rarely (if ever) change
items['/gcs-golfcommunity/api/v2/club/flex-type'] = {
    cacheTimeoutMs: Timeouts.OneMonth,
    persistToDisk: false
};

// Golf Swing Session Stats, last 12 months of data but only one swing session per day
items['/gcs-golfcommunity/api/v2/swing-session/stats'] = {
    cacheTimeoutMs: Timeouts.TenMinutes,
    persistToDisk: false
};

items['/gcs-golfcommunity/api/v2/swing-session/\\d+/stats'] = {
    cacheTimeoutMs: Timeouts.TenMinutes,
    persistToDisk: false
};

items['/gcs-golfcommunity/api/v2/course-snapshot'] = {
    cacheTimeoutMs: Timeouts.TenMinutes,
    persistToDisk: false
};

items['/gcs-golfcommunity/api/v2/course-snapshot/stats'] = {
    cacheTimeoutMs: Timeouts.TenMinutes,
    persistToDisk: false
};

items['/gcs-golfcommunity/api/v2/course-snapshot/player'] = {
    cacheTimeoutMs: Timeouts.TenMinutes,
    persistToDisk: false
};

// User Daily Summary collection, called once for each Wellness widget on the dashboard
items['/usersummary-service/usersummary/list/\\S*\\?start=\\d+&limit=\\d+&maxDate=\\d+'] = {
    cacheTimeoutMs: Timeouts.TenSeconds,
    persistToDisk: false
};

items['/usersummary-service/usersummary/weekAverageRestingHR/\\S*\\?calendarDate=\\d+'] = {
    cacheTimeoutMs: Timeouts.TenSeconds,
    persistToDisk: false
};

items['/device-service/deviceregistration/devices'] = {
    cacheTimeoutMs: Timeouts.TenSeconds,
    persistToDisk: false
};

items['/activitylist-service/activities/fordailysummary/\\S*\\?calendarDate=\\d+'] = {
    cacheTimeoutMs: Timeouts.ThirtySeconds,
    persistToDisk: false
};

items['/wellnessactivity-service/activity/summary/\\d+'] = {
    cacheTimeoutMs: Timeouts.ThirtySeconds,
    persistToDisk: false
};

items['/ghs/ecg/v1/ecg/daily\\d+'] = {
    cacheTimeoutMs: Timeouts.ThirtySeconds,
    persistToDisk: false
};

items['/wellnessactivity-service/activity/summary/list?limit=\\d+&start=\\d+&until=\\d+'] = {
    cacheTimeoutMs: Timeouts.TenSeconds,
    persistToDisk: false
};

items['/wellnessactivity-service/activity/epoch/\\S*'] = {
    cacheTimeoutMs: Timeouts.ThirtySeconds,
    persistToDisk: false
};

// Big payload, called once for every HR widget on the dashboard
items['/wellness-service/wellness/dailyHeartRate?date=\\d+'] = {
    cacheTimeoutMs: Timeouts.OneMinute,
    persistToDisk: false
};

items['/calendar-service/group/\\d+/year/\\d+/month/\\d+'] = {
    cacheTimeoutMs: Timeouts.OneMinute,
    persistToDisk: false
};

items['/calendar-service/group/\\d+/year/\\d+/month/\\d+/day/\\d+/start/\\d+'] = {
    cacheTimeoutMs: Timeouts.OneMinute,
    persistToDisk: false
};

items['/calendar-service/year/\\d+/month/\\d+/day/\\d+/start/\\d+'] = {
    cacheTimeoutMs: Timeouts.OneMinute,
    persistToDisk: false
};

items['/personalrecord-service/personalrecordtype/prtypes/\\S*'] = {
    cacheTimeoutMs: Timeouts.OneDay,
    persistToDisk: false
};

items['/device-service/deviceservice/device-info/active/\\S*'] = {
    cacheTimeoutMs: Timeouts.FiveSeconds,
    persistToDisk: false
};

items['/gear-service/gear/types'] = {
    cacheTimeoutMs: Timeouts.OneDay,
    persistToDisk: false
};

items['/metrics-service/metrics/maxmet/latest/\\d+'] = {
    cacheTimeoutMs: Timeouts.FiveSeconds,
    persistToDisk: false
};

// Big payload, called once for every Stress widget on the dashboard
items['/wellness-service/wellness/dailyStress/\\d+'] = {
    cacheTimeoutMs: Timeouts.OneMinute,
    persistToDisk: false
};

// Big payload, called once for every Sleep widget on the dashboard
items['/wellness-service/wellness/dailySleepData/\\S*\\?date=\\d+'] = {
    cacheTimeoutMs: Timeouts.FiveSeconds,
    persistToDisk: false
};

items['/activity-service/activity/\\d+/exerciseSets'] = {
    cacheTimeoutMs: Timeouts.FiveSeconds,
    persistToDisk: false
};

// Golf Leaderboard Widget - will hit this for each widget on the page
items['/gcs-golfcommunity/api/v2/leaderboard/player/latest'] = {
    cacheTimeoutMs: Timeouts.TenSeconds,
    persistToDisk: false
};

// Golf Leaderboard Page - paging can be abused
items['/gcs-golfcommunity/api/v2/leaderboard/player/played'] = {
    cacheTimeoutMs: Timeouts.FiveSeconds,
    persistToDisk: false
};

items['/gcs-golfcommunity/api/v2/leaderboard/scorecard'] = {
    cacheTimeoutMs: Timeouts.OneMinute,
    persistToDisk: false
};

// Golf Course OMT Search - it's soooooo slow
items['/omt/CourseViewData'] = {
    cacheTimeoutMs: Timeouts.TenMinutes,
    persistToDisk: false
};

// Golf scorecard v2 APIs
items['/gcs-golfcommunity/api/v2/scorecard/summary'] = {
    cacheTimeoutMs: Timeouts.TenSeconds,
    persistToDisk: false
};

// Golf Shot History v2
items['/gcs-golfcommunity/api/v2/shot/course-snapshot/\\d+/hole'] = {
    cacheTimeoutMs: Timeouts.TenMinutes,
    persistToDisk: false
};

// Golf Stats v2
items['/gcs-golfcommunity/api/v2/player/stats'] = {
    cacheTimeoutMs: Timeouts.TenMinutes,
    persistToDisk: false
};

items['/wellness-service/stats/daily/acclimation\\?fromDate=\\S*&untilDate=\\S*'] = {
    cacheTimeoutMs: Timeouts.TenMinutes,
    persistToDisk: false
};

items['/wellness-service/wellness/daily/acclimation/\\S*'] = {
    cacheTimeoutMs: Timeouts.TenSeconds,
    persistToDisk: false
};

items['/race-search/active/location'] = {
    cacheTimeoutMs: Timeouts.TenMinutes,
    persistToDisk: false
};

items['/web-gateway/snapshot/usageIndicators'] = {
    cacheTimeoutMs: Timeouts.TenMinutes,
    persistToDisk: false
};

items['/gear-service/gear/makemodels\\?keywords=\\S*'] = {
    cacheTimeoutMs: Timeouts.OneMonth,
    persistToDisk: false
};

items['/segment-service/leaderboard/activity/\\d+/segment/\\S+/rank/\\S*'] = {
    cacheTimeoutMs: Timeouts.TenMinutes,
    persistToDisk: false
};

items['/fitnessstats-service/activity/availableMetrics\\?startDate=\\S*&endDate=\\S*&activityType=\\S*'] = {
    cacheTimeoutMs: Timeouts.TenMinutes,
    persistToDisk: false
};

items['/fitnessstats-service/activity/availableMetrics\\?startDate=\\S*&endDate=\\S*'] = {
    cacheTimeoutMs: Timeouts.TenMinutes,
    persistToDisk: false
};

items['/calendar-service/upcomingevents/year/\\d+/month/\\d+/day/\\d+/days/\\d+'] = {
    // avoid multiple hits on dashboard load
    cacheTimeoutMs: Timeouts.TenSeconds,
    persistToDisk: false
};

items['/activity-service/activity/\\d+/relative'] = {
    // avoid multiple hits on activity details page
    cacheTimeoutMs: Timeouts.FiveSeconds,
    persistToDisk: false
};

items['/web-data/climb-difficulty/climb-difficulty-master.json'] = {
    cacheTimeoutMs: Timeouts.OneMonth,
    persistToDisk: false
};

items['/periodichealth-service/menstrualcycle/pregnancysnapshot/all'] = {
    // avoid multiple hits to check on pregnancies
    cacheTimeoutMs: Timeouts.TwoSeconds,
    persistToDisk: false
};

// Avoid multiple hits to check on GDPR upload consent
items['/gdprconsent-service/feature/UPLOAD'] = {
    cacheTimeoutMs: Timeouts.FiveSeconds,
    persistToDisk: false
};

// Avoid multiple hits to fetch GDPR consent text
items['/consentTextServices/consentText\\?consentTypeId=\\S*&locale=\\S*'] = {
    cacheTimeoutMs: Timeouts.OneMinute,
    persistToDisk: false
};

items['/activity-service/activity/\\d+/typedsplits'] = {
    cacheTimeoutMs: Timeouts.FiveSeconds,
    persistToDisk: false
};

// Avoid multiple hits to fetch static FTP range data
items['/web-data/userprofile/biometric/bioRanges/ftpBioRanges.json'] = {
    cacheTimeoutMs: Timeouts.ThirtySeconds,
    persistToDisk: false
};

items['/activity-service/activity/\\d+/details'] = {
    cacheTimeoutMs: Timeouts.TenSeconds,
    persistToDisk: false
};

// Avoid multiple hits to fetch static device accessory data
items['/web-data/deviceAccessories/deviceAccessoriesUrls.json'] = {
    cacheTimeoutMs: Timeouts.FiveMinutes,
    persistToDisk: false
};

items['/userprofile-service/userprofile/user-settings/'] = {
    cacheTimeoutMs: Timeouts.OneMinute,
    persistToDisk: false
};

items['/userprofile-service/userprofile/personal-information'] = {
    cacheTimeoutMs: Timeouts.TenSeconds,
    persistToDisk: false
};

export default items;
